import React from 'react'
import { connect } from 'react-redux'
import { downloadAllOrdersAction } from '../../../../actions/appActions'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    MenuItem,
    Select,
} from '@material-ui/core/index'
import { strings } from '../../../../localization/strings'
import Loader from '../../../loaders/dots_loader/index'
import { Grid } from '@material-ui/core'
import DetailsIcon from '@material-ui/icons/NewReleases'

class Component extends React.Component {
    state = {
        open: false,
        loading: false,
        perPage: localStorage.getItem('labelsPerPage') || 1,
    }

    handleClickOpen = () => {
        this.setState({ open: true })
    }

    handleClose = (force) => {
        if (force !== true) {
            if (this.state.loading) return
        }
        this.setState({ open: false, loading: false })
    }

    confirm = () => {
        this.setState({ loading: true })
        const print = this.props.print ? this.props.print : false
        this.props
            .downloadAllOrdersAction(
                this.props.orderIds,
                print,
                this.state.perPage
            )
            .then(() => this.handleClose(true))
            .catch((error) => {
                this.handleClose(true)
                window.showDialog(error)
            })
    }

    render() {
        const print = this.props.print ? this.props.print : false

        return (
            <div style={{ width: '100%' }}>
                <div
                    onClick={this.handleClickOpen}
                    style={{ textAlign: 'left' }}
                >
                    {this.props.print
                        ? strings.downloadOrderAllPrintButton
                        : strings.downloadOrderAllButton}
                </div>

                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {!print
                            ? strings.downloadOrderAllDialogTitle
                            : strings.downloadOrderAllPrintDialogTitle}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText
                            id="alert-dialog-description"
                            style={{ whiteSpace: 'pre-line' }}
                        >
                            {!print
                                ? strings.downloadOrderAllDialogText
                                : strings.downloadOrderAllPrintDialogText}
                        </DialogContentText>
                        <Grid
                            container
                            justify="center"
                            alignItems="center"
                            style={{ marginTop: '15px', marginBottom: '15px' }}
                        >
                            <Grid item>
                                <FormControl variant="outlined" fullWidth>
                                    <Select
                                        value={this.state.perPage}
                                        onChange={(x) => {
                                            this.setState({
                                                perPage: x.target.value,
                                            })
                                            localStorage.setItem(
                                                'labelsPerPage',
                                                x.target.value
                                            )
                                        }}
                                    >
                                        <MenuItem value={1}>
                                            1 {strings.downloadOrderPerPage}
                                        </MenuItem>
                                        <MenuItem value={4}>
                                            4 {strings.downloadOrderPerPages}
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            alignItems="flex-start"
                            style={{ marginTop: '15px', marginBottom: '15px' }}
                        >
                            <Grid item xs={1}>
                                <DetailsIcon
                                    fontSize="large"
                                    color={'primary'}
                                    style={{ marginTop: 20 }}
                                />
                            </Grid>
                            <Grid item xs={11}>
                                <DialogContentText
                                    id="alert-dialog-description"
                                    style={{ whiteSpace: 'pre-line' }}
                                >
                                    {strings.downloadOrderAllSuggestion}
                                </DialogContentText>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.handleClose}
                            color="primary"
                            disabled={this.state.loading}
                        >
                            {strings.close}
                        </Button>
                        <Button
                            onClick={this.confirm}
                            color="primary"
                            autoFocus
                            disabled={this.state.loading}
                        >
                            {strings.continue}
                        </Button>
                    </DialogActions>
                    {this.state.loading ? (
                        <Loader
                            message={strings.downloadOrderAllProgressMessage}
                        />
                    ) : null}
                </Dialog>
            </div>
        )
    }
}

const mapDispatchToProps = { downloadAllOrdersAction }
const mapStateToProps = (store) => ({})
export default connect(mapStateToProps, mapDispatchToProps)(Component)
